export const getApplicationKey = (
  application: number | { id?: string; applicationId?: string; key?: string }
) => {
  if (typeof application === "number") return application.toString()

  return application.applicationId || application.id || application.key
}
